import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { SkeletonLoaderComponent } from '@com-delta-omnichannel/mach';

@Component({
  selector: 'idp-apps-book-widget-mobile-skeleton',
  standalone: true,
  imports: [NgFor, SkeletonLoaderComponent],
  templateUrl: './apps-book-widget-mobile-skeleton.component.html',
  styleUrls: ['./apps-book-widget-mobile-skeleton.component.scss']
})
export class BookWidgetMobileSkeletonComponent {}
